// Shared driver and constructor data for team management

export const drivers = [
  { id: 'max_verstappen', name: 'Max Verstappen', price: 5.5, team: 'Red Bull Racing' },
  { id: 'sergio_perez', name: 'Sergio Perez', price: 4.5, team: 'Red Bull Racing' },
  { id: 'lewis_hamilton', name: 'Lewis Hamilton', price: 5.0, team: 'Mercedes' },
  { id: 'george_russell', name: 'George Russell', price: 4.0, team: 'Mercedes' },
  { id: 'charles_leclerc', name: 'Charles Leclerc', price: 5.0, team: 'Ferrari' },
  { id: 'carlos_sainz', name: 'Carlos Sainz', price: 4.0, team: 'Ferrari' },
  { id: 'lando_norris', name: 'Lando Norris', price: 4.5, team: 'McLaren' },
  { id: 'oscar_piastri', name: 'Oscar Piastri', price: 3.5, team: 'McLaren' },
  { id: 'fernando_alonso', name: 'Fernando Alonso', price: 4.5, team: 'Aston Martin' },
  { id: 'lance_stroll', name: 'Lance Stroll', price: 3.0, team: 'Aston Martin' },
  { id: 'pierre_gasly', name: 'Pierre Gasly', price: 3.0, team: 'Alpine' },
  { id: 'esteban_ocon', name: 'Esteban Ocon', price: 2.5, team: 'Alpine' },
  { id: 'alex_albon', name: 'Alex Albon', price: 2.5, team: 'Williams' },
  { id: 'logan_sargeant', name: 'Logan Sargeant', price: 2.0, team: 'Williams' },
  { id: 'yuki_tsunoda', name: 'Yuki Tsunoda', price: 2.5, team: 'VISA Cash App RB' },
  { id: 'daniel_ricciardo', name: 'Daniel Ricciardo', price: 2.5, team: 'VISA Cash App RB' },
  { id: 'valtteri_bottas', name: 'Valtteri Bottas', price: 2.5, team: 'Kick Sauber' },
  { id: 'zhou_guanyu', name: 'Zhou Guanyu', price: 2.0, team: 'Kick Sauber' },
  { id: 'kevin_magnussen', name: 'Kevin Magnussen', price: 2.0, team: 'Haas F1 Team' },
  { id: 'nico_hulkenberg', name: 'Nico Hulkenberg', price: 2.5, team: 'Haas F1 Team' }
];

export const constructors = [
  { id: 'Red Bull Racing', name: 'Red Bull Racing', price: 5.0 },
  { id: 'Mercedes', name: 'Mercedes', price: 4.5 },
  { id: 'Ferrari', name: 'Ferrari', price: 4.0 },
  { id: 'McLaren', name: 'McLaren', price: 3.5 },
  { id: 'Aston Martin', name: 'Aston Martin', price: 3.0 },
  { id: 'Alpine', name: 'Alpine', price: 2.5 },
  { id: 'Williams', name: 'Williams', price: 2.0 },
  { id: 'VISA Cash App RB', name: 'VISA Cash App RB', price: 2.0 },
  { id: 'Kick Sauber', name: 'Kick Sauber', price: 2.0 },
  { id: 'Haas F1 Team', name: 'Haas F1 Team', price: 2.0 }
];

export const TOTAL_BUDGET = 45.0;

